// Copyright 2021-2023 the .NET Foundation
// Licensed under the MIT License
/** A type-guard function for {@link LoadHipsCatalogMessage}. */
export function isLoadHipsCatalogMessage(o) {
    return o.event === 'layer_hipscat_load' &&
        typeof o.tableId === 'string' &&
        typeof o.name === 'string' &&
        (typeof o.threadId === 'undefined' || typeof o.threadId === 'string');
}
export function isLoadHipsCatalogCompletedMessage(o) {
    return o.event == 'layer_hipscat_load_completed' &&
        typeof o.threadId == 'string' &&
        typeof o.spreadsheetInfo == 'object';
}
/** A type-guard function for {@link GetHipsCatalogDataInViewMessage}. */
export function isGetHipsCatalogDataInViewMessage(o) {
    return o.event === 'layer_hipscat_datainview' &&
        typeof o.threadId === 'string' &&
        typeof o.tableId === 'string' &&
        typeof o.limit === 'boolean';
}
export function isMultiModifyTableLayerMessage(o) {
    return o.event === 'table_layer_set_multi' &&
        typeof o.id === 'string' &&
        typeof o.settings === 'object' &&
        typeof o.values === 'object';
}
export function isMultiModifyFitsLayerMessage(o) {
    return o.event === 'image_layer_set_multi' &&
        typeof o.id === 'string' &&
        typeof o.settings === 'object' &&
        typeof o.values === 'object';
}
export function isMultiModifyAnnotationMessage(o) {
    return o.event === 'annotation_set_multi' &&
        typeof o.id === 'string' &&
        typeof o.settings === 'object' &&
        typeof o.values === 'object';
}
/** A type-guard function for {@link CreateColormapMessage}. */
export function isCreateColormapMessage(o) {
    return o.event === "create_colormap" &&
        typeof o.name === "string" &&
        Array.isArray(o.colors) &&
        (o.colors.every(function (c) { return typeof c === "string"; }) ||
            o.colors.every(function (c) { return Array.isArray(c) && c.length === 4 && c.every(function (x) { return typeof x === "number"; }); }));
}
/** A type-guard function for {@link DeleteColormapMessage} */
export function isDeleteColormapMessage(o) {
    return o.event === "delete_colormap" &&
        typeof o.name === "string";
}
//# sourceMappingURL=layers.js.map